/*eslint-disable */
import {
  bus
} from '../../main';
import videoSocketRef from "../../videoNotificationSocket";
var callAutoDis;
const $ = window.jQuery = require('jquery');
export default {
  name: 'video-call-notification-popup',
  components: {},
  props: ['callerNAME', 'userIDforVideoCall'],
  data () {
    return {
      roomIdForVideoCall:'',
      interClearVal:false
    }
  },
  computed: {

  },
  mounted () {
    callAutoDis = setInterval(() => {
      console.log("Call auto Disconnected!!", "Interval Clear")
      this.callNotAnsweredFun()
      this.interClearVal = true
      if(this.interClearVal == true){
        clearInterval(callAutoDis)
      }
    }, 20000);
  },
  methods: {
    callAcceptFunction(){
      this.$store.dispatch('apiUserRoomCreateForChatFunction', {user:this.userIDforVideoCall}).then((res)=>{
        this.roomIdForVideoCall = res.data.data.id
        videoSocketRef.emit({
          message: `Call Accepted.`,
          type: "videoCallAccepted",
          videoCallRoomId:this.roomIdForVideoCall,
        });
        videoSocketRef.emit({
          message: `Other Tabs Caller Popup Closed.`,
          type: "videoAlertPopupClose",
          videoCallRoomId:this.roomIdForVideoCall,
        });
        bus.$emit('callerNotifiactionBus', false);
        this.$router.push('/video/room/one-to-one-peer/#' + this.roomIdForVideoCall);
        clearInterval(callAutoDis)
        $('body').removeClass('videoNotificationPopup')
      }).catch((err)=>{
      })
    },
    callDeclineFun(){
      videoSocketRef.emit({
        message: `Call Declined.`,
        type: "videoCallDecline",
        videoCallDeclinedId:this.userIDforVideoCall,
      });
      videoSocketRef.emit({
        message: `Other Tabs Caller Popup Closed.`,
        type: "videoAlertPopupClose",
        videoCallRoomId:this.roomIdForVideoCall,
      });
      clearInterval(callAutoDis)
      bus.$emit('callerNotifiactionBus', false);
      $('body').removeClass('videoNotificationPopup')
    },
    callNotAnsweredFun(){
      videoSocketRef.emit({
        message: `Call Not Recieved.`,
        type: "videoCallNotRecieved",
        videoCallDeclinedId:this.userIDforVideoCall,
      });
      videoSocketRef.emit({
        message: `Other Tabs Caller Popup Closed.`,
        type: "videoAlertPopupClose",
        notRecivedCallerId:this.userIDforVideoCall,
      });
      bus.$emit('callerNotifiactionBus', false);
      $('body').removeClass('videoNotificationPopup')
    }
  }
}


